var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStep === _vm.steps.CreateAssign.id),expression:"currentStep === steps.CreateAssign.id"}],staticClass:"box"},[_c('load-quote-create-step',{attrs:{"ecom-type":_vm.ecomType},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }